export default __webpack_public_path__ + "static/media/7.e5aa2b83.jpg";